export default __webpack_public_path__ + "assets/f6f573904846d50f6797392d1ef496b0.png";